import CookieCenter from '@components/common/CookieCenter';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
const CookieCenterLink = (props) => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const parsedOptions = JSON.parse(props.options);
    const hasOneTrust = window.cookiePolicy === 'OneTrust';
    const showCookieCenter = () => {
        if (hasOneTrust) {
            if (window.OneTrust) {
                window.OneTrust.ToggleInfoDisplay();
            }
            else {
                console.error('OneTrust object not found!');
            }
        }
        else {
            setShowModal(true);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { "data-analytics": props.analytics, "aria-haspopup": "dialog", className: "footer-menu__menuitem", onClick: () => showCookieCenter() },
            React.createElement("span", null, props.title)),
        !hasOneTrust && (React.createElement(CookieCenter, { cookiepage: parsedOptions.cookiepage, showModal: showModal, onClose: () => {
                setShowModal(false);
            }, onSubmit: () => {
                setShowModal(false);
            } }))));
};
export default CookieCenterLink;
